import {
  ContactCategoryParameter,
  PlanParameter,
  PositionParameter,
  SectionParameter,
} from './types/parameter';

export const sectionParameterItems: SectionParameter[] = [
  '経理',
  '総務',
  '人事',
  '経営企画',
  'IR',
  '労務',
  'その他',
];

export const positionParameterItems: PositionParameter[] = [
  '経営・役員',
  '部長・マネージャー',
  '課長・リーダー',
  '一般',
];

export const contactCategoryParameterItems: ContactCategoryParameter[] = [
  'Uniforceのサービス内容について',
  '料金について',
  '公認会計士のコンサルサービスについて',
  'その他',
];

export const planParameterItems: PlanParameter[] = [
  '検討中',
  'スタータープラン',
  'スタンダードプラン',
  'アドバンストプラン',
];
